// Pricing calculations — mirror the original Job Card workbook formulas
// Supports vat_mode: exclusive (default), inclusive, none
// Supports extra_line_items (add-ons + admin-defined discounts)
export const calcJob = (job = {}) => {
  const cost = Number(job.cost) || 0;
  const retail = Number(job.retail) || 0;
  const fitment = Number(job.fitment_fee) || 0;
  const moulding = Number(job.moulding) || 0;
  const discountPct = Number(job.discount_pct) || 0;
  const excessPct = Number(job.excess_pct) || 0;
  const excessOverride = Number(job.excess_amount_override) || 0;
  const vatPct = Number(job.vat_pct) || 0;
  const vatMode = (job.vat_mode || "exclusive").toLowerCase();

  const extras = Array.isArray(job.extra_line_items) ? job.extra_line_items : [];
  let extrasPositive = 0;
  let extrasDiscount = 0;
  extras.forEach((it) => {
    const qty = Number(it?.qty || 1);
    const price = Number(it?.unit_price || 0);
    const total = qty * price;
    if (it?.is_discount) extrasDiscount += Math.abs(total);
    else extrasPositive += total;
  });

  // Flatglass items — each pane priced separately, rolls into the retail bucket
  const flatglassItems = Array.isArray(job.flatglass_items) ? job.flatglass_items : [];
  const flatglassTotal = flatglassItems.reduce(
    (sum, it) => sum + (Number(it?.qty) || 0) * (Number(it?.price) || 0),
    0,
  );

  const grossLineSubtotal = retail + fitment + moulding + extrasPositive + flatglassTotal;
  const percentDiscount = grossLineSubtotal * (discountPct / 100);
  const discountAmount = percentDiscount + extrasDiscount;
  let netLines = grossLineSubtotal - discountAmount;
  if (netLines < 0) netLines = 0;

  let subAfterDiscount;
  let vatAmount;
  let inclusiveSubtotal;
  if (vatMode === "none") {
    subAfterDiscount = netLines;
    vatAmount = 0;
    inclusiveSubtotal = netLines;
  } else if (vatMode === "inclusive") {
    inclusiveSubtotal = netLines;
    const divisor = 1 + vatPct / 100;
    subAfterDiscount = divisor ? netLines / divisor : netLines;
    vatAmount = inclusiveSubtotal - subAfterDiscount;
  } else {
    subAfterDiscount = netLines;
    vatAmount = subAfterDiscount * (vatPct / 100);
    inclusiveSubtotal = subAfterDiscount + vatAmount;
  }

  const excessAmount =
    excessOverride > 0
      ? excessOverride
      : inclusiveSubtotal * (excessPct / 100);
  const insuranceTotal = Math.max(inclusiveSubtotal - excessAmount, 0);
  const grossProfit = subAfterDiscount - cost;

  return {
    cost,
    retail,
    fitment,
    moulding,
    discountPct,
    discountAmount,
    grossLineSubtotal,
    subAfterDiscount,
    vatPct,
    vatMode,
    vatAmount,
    inclusiveSubtotal,
    excessPct,
    excessAmount,
    insuranceTotal,
    grossProfit,
    extrasPositive,
    extrasDiscount,
    flatglassTotal,
  };
};

export const money = (n) => {
  const v = Number(n) || 0;
  return "R " + v.toLocaleString("en-ZA", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const formatDate = (s) => {
  if (!s) return "";
  // accept YYYY-MM-DD or DD/MM/YYYY
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) {
    const [y, m, d] = s.substring(0, 10).split("-");
    return `${d}/${m}/${y}`;
  }
  return s;
};
